<template>
  <div>
    <LDBsTable
      url="arena/pointtypes"
      defaultSort="id"
      defaultOrder="asc"
      :query="queryToUse"
      :columns="columns"
      :clear="clear"
      :defaultOptions="options"
    >
      <div class="form-group col-lg-4">
        <label for="id">{{ $t("id") }}</label>
        <input
          type="text"
          id="id"
          name="id"
          class="form-control"
          :placeholder="$t('ph_id')"
          v-model="query.id"
          @input="upper('id')"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="description">{{ $t("description") }}</label>
        <input
          type="text"
          id="description"
          name="description"
          class="form-control"
          :placeholder="$t('ph_description')"
          v-model="query.TPT_DSC"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="code">{{ $t("code") }}</label>
        <input
          type="text"
          id="code"
          name="code"
          class="form-control"
          :placeholder="$t('ph_code')"
          v-model="query.TPT_COD"
        />
      </div>

      <div class="form-group col-lg-12">
        <label for="client">{{ $t("client") }}</label>
        <Combobox
          class="bg-white"
          name="client"
          :placeholder="$t('select_a_item')"
          :options="clients"
          :initial-value="query.CLI_ID"
          label="CLI_DSC"
          v-model="query.CLI_ID"
          :reduce="(client) => client.CLI_ID"
        />
      </div>
    </LDBsTable>
  </div>
</template>

<script>
import LDBsTable from "@/components/shared/LDBsTable";
import Combobox from "@/components/shared/ComboBox";
import { mapState } from "vuex";

export default {
  name: "ArenaVehicleTypeList",

  components: {
    LDBsTable,
    Combobox,
  },

  data() {
    return {
      columns: [
        {
          title: this.$t("ID"),
          field: "id",
          sortable: true,
        },
        {
          title: this.$t("description"),
          field: "TPT_DSC",
          sortable: false,
        },
        {
          title: this.$t("code"),
          field: "TPT_COD",
          sortable: true,
        },
        {
          title: this.$t("client"),
          field: "clientName",
          formatter: (value) => {
            return value || "-";
          },
        },
        {
          key: "id",
          field: "id",
          align: "center",
          width: "100%",
          formatter: function (value) {
            return `
              <a
                href="#/main/arena/point-type/${value}"
                class="edit btn btn-action btn-primary btn-circle light-bottom-shadow text-white"
              >
                <i class="fas fa-pen" />
              </a>
            `;
          },
        },
      ],
      options: {
        exportOptions: { fileName: "arena_tipo_ponto" },
      },
      queryToUse: {},
      query: {
        id: "",
        TPT_DSC: "",
        TPT_COD: "",
        CLI_ID: undefined
      },
    };
  },

  computed: {
    ...mapState({
      lastquery: (state) => state.filtershistory.query,
      clients: state => state.arena.clients,
    }),
  },

  methods: {
    clear() {
      this.query.id = "";
      this.query.TPT_DSC = "";
      this.query.TPT_COD = "";
      this.query.CLI_ID = undefined
    },

    upper(attr) {
      this.query[attr] = this.query[attr].toUpperCase();
    },
  },

  beforeMount() {
    this.queryToUse = this.lastquery["arenapointtype"]
      ? this.lastquery["arenapointtype"]
      : this.query;
  },

  async mounted() {
    await this.$store.dispatch('arena/fetchClients')

    if (this.lastquery["arenapointtype"]) {
      for (const [key, value] of Object.entries(
        this.lastquery["arenapointtype"]
      )) {
        this.query[key] = value;
      }
    }

    this.queryToUse = this.query;
  },

  destroyed() {
    this.$store.dispatch("filtershistory/setQuery", {
      key: "arenapointtype",
      query: this.query,
    });
  },
};
</script>
